export const Clarion = require('./clarion.png');
export const Eon = require('./eon.png');
export const Hta = require('./hta.png');
export const Lendology = require('./lendology.png');
export const London = require('./london.png');
export const Mcs = require('./mcs.png');
export const Se2 = require('./se2.jpg');